import { render } from "./PartnerPromotionViewButtons.vue?vue&type=template&id=7d499f0e&ts=true"
import script from "./PartnerPromotionViewButtons.vue?vue&type=script&lang=ts"
export * from "./PartnerPromotionViewButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__